"use client";

import { Row } from "@faire/web--source/slate/Layout";
import { IBrandSearchQueryUXMessaging } from "@faire/web-api--source/indigofair/data/IBrandSearchQueryUXMessaging";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";

import { BrandMinimum } from "./__internal__/BrandMinimum";
import { BrandRating } from "./__internal__/BrandRating";
import { MaybeInsiderMessageOrBrandBasedIn } from "./__internal__/MaybeInsiderMessageOrBrandBasedIn";

export type IBrandSubtitleProps = Pick<
  ILeanProductTile.IBrand,
  | "avg_brand_review_rating"
  | "minimum_order_amount"
  | "based_in_country_message"
>;

export const BrandSearchDesktopSubtitle: React.FC<{
  isLoading: boolean;
  brand: IBrandSubtitleProps;
  insiderMessage: IBrandSearchQueryUXMessaging | undefined;
}> = ({ isLoading, brand, insiderMessage }) => {
  return (
    <Row align="center" gap="1x">
      <BrandRating brand={brand} />
      <BrandMinimum isLoading={isLoading} brand={brand} />
      <MaybeInsiderMessageOrBrandBasedIn
        isLoading={isLoading}
        insiderMessage={insiderMessage}
        brand={brand}
      />
    </Row>
  );
};

export const BrandSearchMobileSubtitle: React.FC<{
  isLoading: boolean;
  brand: IBrandSubtitleProps;
  insiderMessage: IBrandSearchQueryUXMessaging | undefined;
}> = ({ isLoading, brand, insiderMessage }) => {
  return (
    <Row gap="1x">
      <BrandRating brand={brand} />
      <BrandMinimum isLoading={isLoading} brand={brand} />
      <MaybeInsiderMessageOrBrandBasedIn
        isLoading={isLoading}
        brand={brand}
        insiderMessage={insiderMessage}
      />
    </Row>
  );
};
